import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "form-group col-12 d-flex flex-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "source-of-referral" }, [
  /*#__PURE__*/_createTextVNode(" Referral Source "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_3 = {
  key: 0,
  class: "d-flex flex-wrap"
}
const _hoisted_4 = { class: "form-check custom-radio form-check-inline d-inline" }
const _hoisted_5 = ["id", "checked", "value"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "me-1" }
const _hoisted_8 = { class: "col-12 card flex-row py-2 px-3 row g-0 mb-2" }
const _hoisted_9 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Facility Name "),
    /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
  ])
], -1 /* HOISTED */)
const _hoisted_11 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_12 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "referral-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Facility Point of Contact Name")
], -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "form-group col-12 col-lg-4 pe-lg-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Referring Provider")
], -1 /* HOISTED */)
const _hoisted_16 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_18 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_19 = { for: "referral-source" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1 /* HOISTED */)
const _hoisted_21 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_22 = { class: "form-group col-12 col-lg-4 pe-lg-3" }
const _hoisted_23 = { for: "referral-name" }
const _hoisted_24 = {
  key: 0,
  class: "form-group col-12 col-lg-4 pe-lg-3"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, " Referring Facility ", -1 /* HOISTED */)
const _hoisted_26 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_29 = {
  key: 1,
  class: "form-group col-12 col-lg-4"
}
const _hoisted_30 = { class: "form-check custom-checkbox form-check-inline" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "referral-same-attending-physician"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Will serve as Attending Physician")
], -1 /* HOISTED */)
const _hoisted_32 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_33 = { for: "internal-referral-source" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Other Referral Source Name ")
const _hoisted_35 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_36 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_37 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "referral-source" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Relationship")
], -1 /* HOISTED */)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Relationship", -1 /* HOISTED */)
const _hoisted_40 = ["value"]
const _hoisted_41 = {
  key: 0,
  class: "form-group col-12 col-lg-4 pe-lg-2"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "referral-name" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Describe Other Relationship")
], -1 /* HOISTED */)
const _hoisted_43 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_45 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_46 = { for: "internal-referral-source-name" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Internal Referral Source Name ")
const _hoisted_48 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_49 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_50 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { for: "internal-referral-source" }, " Internal Referral Source ", -1 /* HOISTED */)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("option", { value: 0 }, "Select Source", -1 /* HOISTED */)
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "community-liaison" }, " Community Liaison ", -1 /* HOISTED */)
const _hoisted_56 = {
  key: 4,
  class: "form-group col-12 col-lg-4"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, null, -1 /* HOISTED */)
const _hoisted_58 = { class: "form-group col-12" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { for: "referral-comments" }, " Comments ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.referralSources.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.referralSources, (source) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: `source-of-referral-${source.name}`,
                  class: "form-check-input",
                  name: "source-of-referral",
                  checked: _ctx.referral.sourceOfReferral === source.value,
                  value: source.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.sourceOfReferral) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sourceOfReferralUpdated()))
                }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_5), [
                  [_vModelRadio, _ctx.referral.sourceOfReferral]
                ]),
                _createElementVNode("label", {
                  class: "form-check-label",
                  for: `source-of-referral-${source.name}`
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(source.name), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_6)
              ]))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("section", _hoisted_8, [
      (_ctx.referral.sourceOfReferral == 1)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getVendorList,
                value: _ctx.facility,
                onValueChanged: _ctx.updateFacility,
                placeholder: "Start Typing...",
                onBlurredInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.referral.facilityReferralSourceId.$touch()))
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"]),
              (_ctx.v$.referral.facilityReferralSourceId.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Facility Name is required."))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.facilityReferralSourceContactName) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.facilityReferralSourceContactName]
              ])
            ]),
            (_ctx.isApplicationPalliative)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.getPhysicianList,
                    value: _ctx.physician,
                    onValueChanged: _ctx.updateReferringProvider,
                    "init-value": _ctx.physician,
                    placeholder: "Search Referring Provider "
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getUsersByRole,
                value: _ctx.communityLiaison,
                onValueChanged: _ctx.updateCommunityLiaison,
                "init-value": _ctx.communityLiaison,
                placeholder: "Search Community Liaison"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (_ctx.referral.sourceOfReferral == 2)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, [
                _createTextVNode(" Referring " + _toDisplayString(_ctx.isApplicationPalliative ? "Provider" : "Physician") + " Name ", 1 /* TEXT */),
                _hoisted_20
              ]),
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getPhysicianList,
                value: _ctx.physician,
                onValueChanged: _ctx.updatePhysician,
                onBlurredInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.referral.physicianReferralSourceName.$touch())),
                "init-value": _ctx.physician,
                placeholder: "Start Typing..."
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"]),
              (_ctx.v$.referral.physicianReferralSourceName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Provider Name is required."))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("label", _hoisted_23, [
                _createElementVNode("span", null, _toDisplayString(_ctx.isApplicationPalliative ? "Provider" : "Physician") + " Point of Contact Name", 1 /* TEXT */)
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                type: "text",
                placeholder: "Enter Name",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.physicianReferralSourceContactName) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.referral.physicianReferralSourceContactName]
              ])
            ]),
            (_ctx.isApplicationPalliative)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_TypeaheadInput, {
                    getData: _ctx.getVendorList,
                    value: _ctx.referringFacility,
                    onValueChanged: _ctx.updateReferringFacility,
                    placeholder: "Search Referring Facility"
                  }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged"])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getUsersByRole,
                value: _ctx.communityLiaison,
                onValueChanged: _ctx.updateCommunityLiaison,
                "init-value": _ctx.communityLiaison,
                placeholder: "Search Community Liaison"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
            ]),
            _hoisted_28,
            (!_ctx.isApplicationPalliative)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "referral-same-attending-physician",
                      class: "form-check-input au-target",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.referral.sameAsAttendingPhysician) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.referral.sameAsAttendingPhysician]
                    ]),
                    _hoisted_31
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (_ctx.referral.sourceOfReferral == 3)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("label", _hoisted_33, [
                _hoisted_34,
                (_ctx.isApplicationPalliative)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, "*"))
                  : _createCommentVNode("v-if", true)
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                type: "text",
                placeholder: "Enter Name of Referral Source",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referral.otherReferralSourceName) = $event)),
                onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.referral.otherReferralSourceName.$touch()))
              }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                [_vModelText, _ctx.referral.otherReferralSourceName]
              ]),
              (_ctx.v$.referral.otherReferralSourceName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Other Referral Source Name is required."))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _hoisted_38,
              _withDirectives(_createElementVNode("select", {
                name: "relationship",
                class: "form-select",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referral.otherReferralSourceRelationship) = $event))
              }, [
                _hoisted_39,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.relationships, (rel) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: rel.value
                  }, _toDisplayString(rel.name), 9 /* TEXT, PROPS */, _hoisted_40))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.otherReferralSourceRelationship]
              ])
            ]),
            (_ctx.showRelationshipDescription)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _hoisted_42,
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control",
                    type: "text",
                    placeholder: "Enter Relationship",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.referral.otherReferralSourceRelationshipDescription) = $event))
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.referral.otherReferralSourceRelationshipDescription]
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getUsersByRole,
                value: _ctx.communityLiaison,
                onValueChanged: _ctx.updateCommunityLiaison,
                "init-value": _ctx.communityLiaison,
                placeholder: "Search Community Liaison"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (_ctx.referral.sourceOfReferral == 4)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, [
                _hoisted_47,
                (_ctx.isApplicationPalliative)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "*"))
                  : _createCommentVNode("v-if", true)
              ]),
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getUsersByRole,
                value: _ctx.internalReferralSource,
                onValueChanged: _ctx.updateInternalReferralSource,
                "init-value": _ctx.internalReferralSource,
                onBlurredInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.referral.internalReferralSourceId.$touch())),
                placeholder: "Start Typing..."
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"]),
              (_ctx.v$.referral.internalReferralSourceId.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_49, "Internal Referral Source Name is required."))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _withDirectives(_createElementVNode("select", {
                name: "internalReferralSource",
                class: "form-select",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.referral.internalReferralSource) = $event))
              }, [
                _hoisted_52,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.InternalReferralSource, (data) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: data.value
                  }, _toDisplayString(data.name), 9 /* TEXT, PROPS */, _hoisted_53))
                }), 256 /* UNKEYED_FRAGMENT */))
              ], 512 /* NEED_PATCH */), [
                [_vModelSelect, _ctx.referral.internalReferralSource]
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _hoisted_55,
              _createVNode(_component_TypeaheadInput, {
                getData: _ctx.getUsersByRole,
                value: _ctx.communityLiaison,
                onValueChanged: _ctx.updateCommunityLiaison,
                "init-value": _ctx.communityLiaison,
                placeholder: "Search Community Liaison"
              }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value"])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (_ctx.isApplicationPalliative && (_ctx.referral.sourceOfReferral == 2 || _ctx.referral.sourceOfReferral == 1))
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _withDirectives((_openBlock(), _createElementBlock("button", {
              type: "button",
              class: _normalizeClass(`btn btn-primary ${_ctx.referral.sourceOfReferral == 1 ? 'mt-4' : ''}`),
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleRedirection(_ctx.referral.sourceOfReferral)))
            }, [
              _createTextVNode(" Add " + _toDisplayString(_ctx.referral.sourceOfReferral == 2 ? "Provider" : "Facility"), 1 /* TEXT */)
            ], 2 /* CLASS */)), [
              [_directive_tooltip, {
                    title: `You will be redirected to solution to add 
                ${_ctx.referral.sourceOfReferral == 2 ? 'provider' : 'facility'} without navigating from current screen.`
                }]
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _hoisted_57,
    _createElementVNode("div", _hoisted_58, [
      _hoisted_59,
      _createVNode(_component_CommentInput, {
        "input-name": "referral-comments",
        result: _ctx.referral.comments,
        onResultUpdatedAppended: _ctx.resultUpdatedAppended,
        onResultUpdated: _ctx.resultUpdated,
        placeholder: "Enter Comments",
        "class-list": _ctx.commentInputClass,
        application: _ctx.referral.application
      }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "class-list", "application"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}